import 'css-chunk:../../frontend/phi3d/src/js/components/FormToggle.module.scss';export default {
  "checkbox": "_checkbox_w901d_1",
  "white": "_white_w901d_29",
  "inset": "_inset_w901d_29",
  "checked": "_checked_w901d_36"
};